module.exports = __webpack_public_path__ + "static/media/TeilnahmebedingungenGs.83e57a04.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/TeilnahmebedingungenGs.pdf
// module id = 1518
// module chunks = 0